/**
 * @description 文件来源编号
 */
export enum OriginSnEnum {
	ORIGIN_SN_FORM = 3101, // 律所

}
